import { ArtichokeService } from "@fidget/common/services/artichokeService";
import { createContext, useContext } from "react";
import { AgentCallService } from "../services/AgentCallService";
import { OIDCService } from "../services/OIDCService";
import { RingtoneService } from "../services/ringtoneService";
import { SpinnerService } from "../services/spinner/spinnerService";

export interface AgentServices {
  spinnerService: SpinnerService;
  artichokeService: ArtichokeService;
  oidcService: OIDCService;
  callService: AgentCallService;
  ringtoneService: RingtoneService;
}

export const AgentServicesContext = createContext<AgentServices | undefined>(undefined);
AgentServicesContext.displayName = "AgentServicesContext"; // for name to display in dev tools

export const useAgentServices = (): AgentServices => {
  const context = useContext(AgentServicesContext);
  if (!context) {
    throw Error("useAgentServices must be used within AgentServicesContext Provider");
  }

  return context;
};
